module.exports = __webpack_public_path__ + "0bd90632c642de47ed323b2a7f297f73.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-folders/shared-folders.html
// module id = 1825
// module chunks = 0